// src/meta-pixel.ts
var dispatchMetaPixelEvent = (event) => {
  if (typeof window === "undefined" || !window.fbq) return;
  switch (event.name) {
    case "shows_browsed":
      window.fbq("track", "ViewContent", {
        content_type: "product_group",
        content_category: "shows"
      });
      break;
    case "show_viewed":
      window.fbq("track", "ViewContent", {
        content_ids: [event.data.vivenuEventId],
        content_name: event.data.showName,
        content_type: "product",
        content_category: "shows"
      });
      break;
    case "seat_map_viewed":
      window.fbq("track", "ViewContent", {
        content_ids: [event.data.vivenuPerformanceId],
        content_name: event.data.showName,
        content_type: "product",
        content_category: "tickets"
      });
      break;
    // These events are handled by Vivenu's native Meta Pixel integration
    case "checkout_completed":
      break;
    case "product_checkout":
      break;
    // No Meta Pixel equivalent for generic UI interactions
    case "button_interaction":
      break;
    case "link_interaction":
      break;
  }
};

export {
  dispatchMetaPixelEvent
};
